import { BaseModel, HasId } from '@app/shared/models/base';
import { Vehicle, VehicleSummary } from '@app/shared/models/vehicle';
import { Accident, AccidentSummary } from '@app/shared/models/accident';
import { ParticipantSummary, ParticipantSummaryObject } from '@app/shared/models/participant';
import { CommentSummary, SMPComment } from '@app/shared/models/comment';
import { ResultSummary } from '@app/shared/models/case-result';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export class CaseSummaryGeneral extends BaseModel {
    public claim_datetime: Date;
    public creation_date: Date;
    public vehicle_leased: boolean;
    public vehicle_financed: boolean;
    public legal_protection: boolean;
    public tax_deduction: boolean;

    public readonly trans = {
        claim_date: marker('case_summary_general.claim_date'),
        creation_date: marker('case_summary_general.creation_date'),
        vehicle_leased: marker('case_summary_general.vehicle_leased'),
        vehicle_financed: marker('case_summary_general.vehicle_financed'),
        legal_protection: marker('case_summary_general.legal_protection'),
        tax_deduction: marker('case_summary_general.tax_deduction')
    };

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            claim_datetime: json && json.claim_datetime ? new Date(json.claim_datetime) : null,
            creation_date: json && json.creation_date ? new Date(json.creation_date) : null
        });
    }
}

export class DecisionSummary extends BaseModel {
    public decision: string;
    public comment: string;

    public readonly trans = {
        decision: marker('decision_summary.decision'),
        comment: marker('decision_summary.comment')
    };

    constructor(json?: any) {
        super(json);
    }
}

export class CaseSummary extends BaseModel
                         implements HasId {
    get id() {
        return this.caseId;
    }

    public caseId: string; // Not received from the BE

    public accident: AccidentSummary;
    public general: CaseSummaryGeneral;
    public vehicle: VehicleSummary;
    public participants: ParticipantSummary[];
    public comments: CommentSummary[];
    public result: ResultSummary;
    public decision: DecisionSummary;

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            accident: new Accident(json && json.accident),
            general: new CaseSummaryGeneral(json && json.general),
            vehicle: new Vehicle(json && json.vehicle),
            participants: json && json.participants ? json.participants.map(part => new ParticipantSummaryObject(part)) : [],
            comments: json && json.comments ? json.comments.map(comment => new SMPComment(comment)) : [],
            result: new ResultSummary(json && json.result),
            decision: new DecisionSummary(json && json.decision)
        });
    }
}
